import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import Filter from '../Common/FilterCustom';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Zona', accessor: 'zone' },
  { Header: 'Ruta', accessor: 'route' },
  { Header: 'Total Clientes', accessor: 'customer' },
  { Header: 'Puntos GPS', accessor: 'marked' },
  { Header: 'Sin GPS', accessor: 'notMarked' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Marked(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);
  const [markeds, setMarkeds] = useState([]);

  async function listMarkeds(search) {
    let filter = {};
    if (search) {
      if (search.base_zone_id) {
        filter.base_zone_id = search.base_zone_id;
      }
    }
    setDataLoading(true);
    let response = await wsFindBy('base/customer-route/marked-points', filter);
    setDataLoading(false);    
    if (response.success) {
      setMarkeds(response.data);
    }
  }

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color={props.themeContext.buttonColor}>
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Listado de puntos{dataLoading && <LoadingSpinner />}</h4>
      </CardHeader>
      <CardBody>
        <Filter getFilter={listMarkeds} zone />

        <ReactTable
          excelName="Puntos"
          defaultWidth={1000}
          indexRow={[0, 1, /*  2, */ 3, 4, 5, 6]}
          widthRow={[80, 100, /* 500,  */ 150, 150, 150, 10]}
          columns={columns}
          data={markeds.map((marked, i) => {
            return {
              num: i + 1,
              zone: marked.zone_code,
              route: marked.route_description,
              customer: marked.total_clients,
              marked: marked.marked,
              notMarked: parseFloat(marked.total_clients) - parseFloat(marked.marked),
              actions: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
